/* ============================================================
   Torshi × BundleSuite — integration glue
   The app embed's custom_section_class is set to
   "torshi-builder-mount" (settings_data.json), so the native PDP
   stays intact and the builder mounts into the div this script
   creates right below it. Loaded only on bundle-builder pages
   (see theme.liquid).
   ============================================================ */
(function () {
  'use strict';

  var MOUNT_CLASS = 'torshi-builder-mount';

  /* Page variant. The bundle product renders through more than one
     template: the generic landing page and audience-specific alternates
     (?view=host for the charcuterie-board / Experienced Host page).
     An alternate template drops <span data-torshi-page="..."> into the
     PDP; everything here that is copy-specific keys off it. */
  function pageVariant() {
    var m = document.querySelector('[data-torshi-page]');
    return m ? m.getAttribute('data-torshi-page') : 'default';
  }
  var VARIANT_TITLES = { host: 'The Crunchy, Tangy Side for Your Charcuterie Board' };
  function patchTitle() {
    var t = VARIANT_TITLES[pageVariant()];
    if (!t) return;
    var h1 = document.querySelector('.main-product-section h1');
    if (h1 && h1.textContent.trim() !== t) h1.textContent = t;
    if (document.title.indexOf(t) !== 0) document.title = t + ' – Torshi';
  }

  /* Create the builder mount right after the main product section.
     This file is deferred, so it runs after DOM parse but before
     DOMContentLoaded handlers — i.e. before the app looks for it. */
  function ensureMount() {
    if (document.querySelector('.' + MOUNT_CLASS)) return false;
    var main = document.querySelector('.main-product-section');
    if (!main) return false;
    var div = document.createElement('div');
    div.className = MOUNT_CLASS;
    main.after(div);
    return true;
  }
  ensureMount();

  /* The placeholder product is $0.00 — swap the hidden native price
     row for per-jar pricing. */
  /* Audience pages run two-line hooks. The rotating block stacks its
     slides absolutely, so the band only has the height it is told; a
     fixed number either clips on phones or leaves air on desktop.
     Measure the tallest slide and size the band to it. */
  var hookFitBound = false;
  function fitHookBand() {
    if (pageVariant() === 'default') return;
    var band = document.querySelector('[class*="ai-auto-text-content-"]');
    if (!band) return;
    var items = band.querySelectorAll('[class*="ai-auto-text-item-"]');
    var max = 0;
    items.forEach(function (it) { max = Math.max(max, it.scrollHeight); });
    if (max > 0) band.style.setProperty('min-height', (max + 4) + 'px', 'important');
    if (!hookFitBound) {
      hookFitBound = true;
      window.addEventListener('resize', fitHookBand);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitHookBand);
      setTimeout(fitHookBand, 800);
    }
  }

  function patchPdp() {
    patchTitle();
    fitHookBand();
    var priceRow = document.querySelector('.main-product-section .product__price');
    if (priceRow && !document.querySelector('.torshi-price-line')) {
      var line = document.createElement('div');
      line.className = 'torshi-price-line';
      line.innerHTML = 'From <strong>$10.00</strong> / jar <span class="torshi-save-chip">Save up to 20%</span>';
      priceRow.insertAdjacentElement('afterend', line);
    }
  }

  function patchButtons() {
    document.querySelectorAll('#bundlesuiteContainer .add-button').forEach(function (btn) {
      if (btn.getAttribute('data-stock-status') === 'in-stock' && btn.textContent.trim() === 'Add to Cart') {
        btn.textContent = 'Add to Box';
      }
    });
  }

  /* The PDP heading block introduces both paths: preset or custom.
     The compact preset card is injected right after it. */
  function findCustomizeBlock() {
    var meta = document.querySelector('.main-product-section .product__meta');
    if (!meta) return null;
    var blocks = meta.querySelectorAll(':scope > .product__block');
    for (var i = 0; i < blocks.length; i++) {
      var t = blocks[i].textContent;
      /* must be a heading block — the mini-callouts block carries hidden
         "Build your…" copy and matched first on the generic page */
      if (!blocks[i].querySelector('h3')) continue;
      if (t.indexOf('Customize your box below') > -1 || t.indexOf('Select the most popular') > -1 || t.indexOf('Build your') > -1) {
        return blocks[i];
      }
    }
    return null;
  }
  function patchCustomizeHeading() {
    var block = findCustomizeBlock();
    if (!block) return;
    var h = block.querySelector('h3');
    if (h && h.textContent.indexOf('Customize your box below') > -1) {
      h.innerHTML = '<strong>Build your Torshi box👇</strong>';
    }
  }

  /* ---- Heat meter (2026-09-10) ----
     The label's "Mild / Doux" heat scale, lifted vector-for-vector from
     the V6 label art (one filled chili, three outlined), placed under
     "See flavors & ingredients". All five flavours share the same mild
     rating, so one block serves the whole box. */
  var HEAT_SVG = "<svg class=\"torshi-heat-chilis\" viewBox=\"170.5 177.8 25 13.5\" aria-hidden=\"true\" focusable=\"false\"><path d=\"M 182.41 181.33 C 182.26 181.34 182.05 181.37 181.93 181.38 L 181.72 181.41 L 181.92 181.25 C 182.14 181.06 182.19 180.96 182.46 180.16 C 182.67 179.51 182.86 179.16 183.11 178.91 C 183.29 178.75 183.45 178.72 183.55 178.85 C 183.59 178.91 183.55 178.96 183.38 179.14 C 183.06 179.48 182.92 179.80 182.82 180.49 C 182.78 180.75 182.88 180.98 183.13 181.25 L 183.27 181.39 L 182.97 181.35 C 182.80 181.33 182.55 181.32 182.41 181.33 M 187.78 181.34 C 187.47 181.34 187.13 181.36 187.01 181.39 L 186.81 181.44 L 187.02 181.26 C 187.28 181.05 187.28 181.03 187.59 180.17 C 187.92 179.22 188.25 178.74 188.55 178.77 C 188.75 178.78 188.75 178.93 188.56 179.10 C 188.21 179.42 187.98 180.01 187.98 180.58 C 187.98 180.85 188.05 181.01 188.26 181.26 C 188.35 181.34 188.34 181.34 187.78 181.34 M 177.75 181.5 C 177.47 181.51 177.15 181.55 176.97 181.60 L 176.67 181.68 L 177.05 181.36 L 177.44 181.04 L 177.60 180.56 C 177.91 179.69 178.08 179.31 178.26 179.08 C 178.48 178.81 178.57 178.75 178.72 178.76 C 178.91 178.79 178.91 178.94 178.72 179.10 C 178.40 179.39 178.23 179.76 178.14 180.38 C 178.08 180.70 178.09 180.75 178.19 180.92 C 178.25 181.03 178.38 181.21 178.49 181.31 C 178.59 181.42 178.70 181.53 178.72 181.55 C 178.75 181.58 178.67 181.57 178.49 181.54 C 178.31 181.5 178.06 181.48 177.75 181.5\"/><path d=\"M 178.85 178.84 C 178.88 178.91 178.83 179.00 178.72 179.10 C 178.83 179.00 178.87 178.91 178.85 178.84 M 188.00 180.28 C 188.01 180.17 188.04 180.07 188.07 179.96 C 188.07 179.97 188.06 179.98 188.06 179.99 C 188.03 180.09 188.01 180.19 188.00 180.28 M 182.26 180.71 C 182.32 180.57 182.39 180.36 182.46 180.16 C 182.38 180.40 182.32 180.58 182.26 180.71 M 187.37 180.77 C 187.43 180.62 187.51 180.39 187.59 180.17 C 187.5 180.44 187.43 180.63 187.37 180.77 M 188.06 180.97 C 188.00 180.85 187.98 180.74 187.98 180.59 C 187.98 180.74 188.01 180.86 188.06 180.97 M 182.86 180.26 C 182.90 180.07 182.94 179.91 182.99 179.76 C 182.97 179.82 182.95 179.89 182.93 179.96 C 182.90 180.08 182.88 180.18 182.86 180.26 M 177.44 181.04 L 177.42 181.06 L 177.56 180.69 C 177.57 180.65 177.59 180.61 177.60 180.57 Z M 177.82 179.98 C 177.83 179.95 177.84 179.92 177.85 179.90 C 178.01 179.42 178.23 179.05 178.44 178.88 C 178.39 178.92 178.33 178.99 178.26 179.08 C 178.12 179.25 178.00 179.50 177.82 179.98 M 176.73 189.98 C 176.82 190.01 177.09 190.02 177.32 190.01 C 178.37 189.96 179.57 189.51 180.89 188.66 C 181.94 187.98 182.64 187.21 183.13 186.20 C 183.51 185.41 183.70 184.62 183.80 183.45 C 183.88 182.42 183.80 182.08 183.43 181.80 C 183.26 181.67 183.24 181.67 182.71 181.66 C 181.77 181.63 181.19 181.84 180.98 182.27 C 180.90 182.45 180.89 182.61 180.88 183.85 L 180.88 185.23 L 180.74 185.56 C 180.25 186.69 179.07 187.91 177.18 189.23 C 176.57 189.66 176.40 189.83 176.49 189.91 C 176.52 189.92 176.62 189.96 176.73 189.98 M 181.84 189.97 C 182.35 190.12 183.34 189.96 184.29 189.58 C 185.13 189.25 186.25 188.57 186.85 188.05 C 188.21 186.86 188.92 185.16 188.94 183.01 L 188.95 182.26 L 188.79 182.03 C 188.57 181.71 188.41 181.65 187.76 181.65 C 187.18 181.65 186.67 181.75 186.42 181.92 C 186.33 181.98 186.21 182.12 186.14 182.25 C 186.01 182.46 186.01 182.48 186.01 183.85 L 186.01 185.23 L 185.87 185.56 C 185.36 186.72 184.17 187.94 182.26 189.27 C 181.71 189.65 181.53 189.83 181.61 189.89 C 181.62 189.91 181.73 189.94 181.84 189.97 M 177.75 181.5 C 178.06 181.48 178.31 181.50 178.49 181.54 C 178.67 181.58 178.75 181.58 178.72 181.55 C 178.70 181.53 178.59 181.42 178.49 181.31 C 178.44 181.26 178.38 181.20 178.33 181.13 C 178.45 181.28 178.63 181.46 178.89 181.68 C 179.28 182.04 179.35 182.31 179.29 183.33 C 179.17 185.20 178.69 186.50 177.69 187.63 C 177.33 188.03 177 188.31 176.39 188.72 C 175.49 189.32 174.51 189.78 173.64 190.01 C 173.28 190.10 173.07 190.13 172.59 190.14 C 171.92 190.16 171.69 190.11 171.59 189.93 C 171.50 189.78 171.64 189.62 172.17 189.24 C 174.46 187.64 175.68 186.30 175.97 185.09 C 176.04 184.82 176.04 184.67 175.99 184.14 C 175.91 183.40 175.95 182.60 176.07 182.28 C 176.15 182.07 176.23 182.00 176.78 181.57 L 177.01 181.40 L 176.67 181.68 L 176.97 181.60 C 177.15 181.55 177.47 181.51 177.75 181.5 M 187.78 181.34 C 188.34 181.34 188.35 181.34 188.26 181.26 C 188.25 181.23 188.23 181.21 188.21 181.19 C 188.30 181.29 188.43 181.37 188.59 181.44 C 188.90 181.57 189.13 181.82 189.26 182.13 C 189.34 182.35 189.35 182.47 189.32 183.16 C 189.21 186.16 188.03 188.02 185.39 189.41 C 184.56 189.85 183.76 190.14 183.01 190.26 C 182.04 190.43 181.23 190.24 181.23 189.85 C 181.23 189.66 181.35 189.51 181.84 189.17 C 184.02 187.60 185.05 186.57 185.52 185.44 C 185.64 185.16 185.65 185.11 185.65 183.79 C 185.65 182.58 185.66 182.40 185.75 182.20 C 185.87 181.91 186.16 181.66 186.54 181.52 C 186.78 181.43 187.02 181.28 187.17 181.14 C 187.13 181.17 187.08 181.21 187.02 181.26 L 186.81 181.44 L 187.01 181.39 C 187.13 181.36 187.47 181.34 187.78 181.34 M 182.41 181.33 C 182.55 181.32 182.80 181.33 182.97 181.35 L 183.27 181.39 L 183.13 181.25 C 183.01 181.11 182.92 180.99 182.87 180.87 C 182.87 180.88 182.89 180.90 182.89 180.91 C 183.02 181.14 183.26 181.40 183.34 181.40 C 183.38 181.40 183.51 181.46 183.63 181.53 C 183.98 181.73 184.17 182.10 184.20 182.62 C 184.23 183.13 184.13 184.17 184.00 184.78 C 183.62 186.54 182.68 187.90 181.16 188.88 C 179.96 189.66 178.79 190.13 177.75 190.28 C 176.80 190.41 176.10 190.23 176.10 189.85 C 176.10 189.66 176.24 189.5 176.73 189.15 C 176.97 188.98 177.55 188.54 178.01 188.17 C 179.17 187.24 179.87 186.48 180.26 185.69 C 180.53 185.17 180.57 184.91 180.50 183.98 C 180.38 182.37 180.59 181.81 181.44 181.51 C 181.71 181.41 181.95 181.25 182.09 181.06 C 182.05 181.13 181.99 181.19 181.92 181.25 L 181.72 181.41 L 181.93 181.38 C 182.05 181.37 182.26 181.34 182.41 181.33\"/><path d=\"M 192.81 181.41 C 192.50 181.41 192.15 181.43 192.04 181.46 L 191.83 181.51 L 192.05 181.33 C 192.30 181.12 192.31 181.11 192.62 180.24 C 192.95 179.29 193.28 178.81 193.57 178.84 C 193.77 178.85 193.78 179.00 193.59 179.17 C 193.24 179.5 193.00 180.08 193.00 180.65 C 193.00 180.92 193.07 181.08 193.29 181.33 C 193.37 181.41 193.37 181.41 192.81 181.41\"/><path d=\"M 193.03 180.35 C 193.04 180.24 193.06 180.14 193.09 180.04 C 193.09 180.04 193.09 180.05 193.08 180.06 C 193.06 180.16 193.04 180.26 193.03 180.35 M 192.40 180.84 C 192.46 180.69 192.54 180.47 192.62 180.24 C 192.52 180.51 192.45 180.71 192.40 180.84 M 193.08 181.04 C 193.03 180.93 193.00 180.81 193.00 180.67 C 193.01 180.81 193.03 180.93 193.08 181.04 M 186.86 190.04 C 187.37 190.19 188.37 190.03 189.31 189.65 C 190.16 189.32 191.28 188.65 191.88 188.12 C 193.24 186.93 193.94 185.23 193.96 183.08 L 193.97 182.33 L 193.82 182.10 C 193.60 181.78 193.44 181.72 192.79 181.72 C 192.21 181.72 191.69 181.83 191.44 182 C 191.36 182.05 191.23 182.20 191.17 182.32 C 191.04 182.54 191.04 182.55 191.04 183.92 L 191.04 185.30 L 190.90 185.63 C 190.38 186.79 189.20 188.01 187.29 189.34 C 186.74 189.73 186.55 189.90 186.64 189.96 C 186.65 189.98 186.75 190.01 186.86 190.04 M 192.81 181.41 C 193.37 181.41 193.37 181.41 193.29 181.33 C 193.27 181.30 193.25 181.28 193.23 181.26 C 193.33 181.36 193.46 181.44 193.62 181.51 C 193.92 181.64 194.16 181.89 194.28 182.20 C 194.37 182.42 194.37 182.54 194.35 183.23 C 194.23 186.23 193.06 188.09 190.41 189.48 C 189.58 189.92 188.79 190.21 188.03 190.33 C 187.07 190.50 186.25 190.31 186.25 189.93 C 186.25 189.73 186.38 189.59 186.86 189.24 C 189.05 187.67 190.07 186.64 190.55 185.51 C 190.67 185.23 190.67 185.18 190.67 183.86 C 190.67 182.66 190.69 182.47 190.77 182.27 C 190.89 181.98 191.18 181.73 191.57 181.59 C 191.81 181.50 192.05 181.35 192.19 181.21 C 192.15 181.25 192.11 181.28 192.05 181.33 L 191.83 181.51 L 192.04 181.46 C 192.15 181.43 192.50 181.41 192.81 181.41\"/></svg>";
  function ensureHeatMeter() {
    if (document.querySelector('.torshi-heat')) return;
    var meta = document.querySelector('.main-product-section .product__meta');
    if (!meta) return;
    var trigger = meta.querySelector('a.modal-trigger');
    var flavBlock = trigger && trigger.closest('.product__block');
    if (!flavBlock) return;
    var el = document.createElement('div');
    el.className = 'torshi-heat product__block';
    el.setAttribute('role', 'img');
    el.setAttribute('aria-label', 'Heat level: mild, 1 of 4');
    el.innerHTML =
      '<span class="torshi-heat-caption">Heat level</span>' +
      '<span class="torshi-heat-badge">' +
      '<span class="torshi-heat-words"><b>Mild</b><i>Doux</i></span>' +
      HEAT_SVG +
      '</span>';
    flavBlock.insertAdjacentElement('afterend', el);
  }

  /* There is only one set — drop the "from Set 1" suffix the app
     appends to the section heading. */
  function patchSectionTitles() {
    document.querySelectorAll('#bundlesuiteContainer .section-title').forEach(function (h) {
      var t = h.textContent;
      var stripped = t.replace(/\s*from Set\s*\d+\s*$/i, '');
      if (stripped !== t) h.textContent = stripped;
    });
  }

  /* Cart stepper copy clean-up:
     - "Fixed price $120.00" ×4 can never fit on one line — trim to the
       price alone.
     - Percentage tiers come out of the app at full float precision
       ("11.11111111% OFF") — round them to whole numbers.
     The untouched original is kept in data-torshi-raw so getTiers()
     keeps doing the pricing math on the exact value. */
  function tidyTierValue(text) {
    var fixed = text.match(/^\s*Fixed price\s*(\$[\d,.]+)\s*$/i);
    if (fixed) return fixed[1];
    var pct = text.match(/^\s*([\d.]+)\s*%\s*(OFF)?\s*$/i);
    if (pct) return Math.round(parseFloat(pct[1])) + '%' + (pct[2] ? ' OFF' : '');
    return null;
  }
  function patchStepperLabels() {
    /* both stepper copies the app renders — the cart one and the
       (currently hidden) in-content one */
    document.querySelectorAll('#bundlesuiteContainer .discount-stepper-item .discount-value p').forEach(function (p) {
      var txt = p.textContent;
      var out = tidyTierValue(txt);
      if (out !== null && out !== txt) {
        p.setAttribute('data-torshi-raw', txt);
        p.textContent = out;
      }
    });
    /* progress banner: "Add 3 items more to get 11.11111111% OFF" */
    document.querySelectorAll('#bundlesuiteContainer .discount-info-container-header h3').forEach(function (h) {
      var txt = h.textContent;
      var out = txt.replace(/(\d+\.\d+)\s*%/g, function (_, n) { return Math.round(parseFloat(n)) + '%'; });
      if (out !== txt) h.textContent = out;
    });
    /* one-line caption so the tier strip explains itself. Fixed-box
       mode needs no caption — the box cards carry their own prices and
       the app prints "Add N more item(s) to fill your box" underneath. */
    document.querySelectorAll('#bundlesuiteContainer .side-cart-stepper .discount-stepper').forEach(function (strip) {
      if (strip.classList.contains('boxed-discount-stepper')) {
        /* the app can render a plain strip first and swap in the boxed
           one — drop a caption left behind by that first render */
        var stale = strip.nextElementSibling;
        if (stale && stale.classList.contains('torshi-stepper-caption')) stale.remove();
        return;
      }
      var next = strip.nextElementSibling;
      if (next && next.classList.contains('torshi-stepper-caption')) return;
      var cap = document.createElement('p');
      cap.className = 'torshi-stepper-caption';
      cap.textContent = 'Add more items to get this much off';
      strip.parentNode.insertBefore(cap, strip.nextSibling);
    });
  }

  /* Fixed-box cards ship with the box price only ("$75.00"), which hides
     the whole offer. Show what the jars cost loose (size × jar price)
     struck through, with the box price next to it — same language as the
     Classic 6 card. The data attributes the pricing math reads are left
     untouched; only the visible text is rewritten. */
  function money(n) {
    return '$' + n.toFixed(2);
  }
  function jarPrice() {
    var cards = inStockCards();
    if (!cards.length) return 0;
    var t = ((cards[0].querySelector('.product-price p') || {}).textContent || '');
    return parseFloat(t.replace(/[^\d.]/g, '')) || 0;
  }
  function patchBoxOptions() {
    var stepper = document.querySelector('#bundlesuiteContainer .side-cart-stepper');
    if (stepper) {
      stepper.classList.toggle('torshi-boxed',
        !!stepper.querySelector('.boxed-discount-stepper'));
    }
    var jar = jarPrice();
    document.querySelectorAll('#bundlesuiteContainer .box-options-container .box-option[data-box-size]')
      .forEach(function (opt) {
        var size = parseInt(opt.getAttribute('data-box-size'), 10);
        var cents = parseInt(opt.getAttribute('data-box-price'), 10);
        if (!(size > 0) || !(cents > 0)) return;
        /* the preset box is the hero — CSS hangs the "Best Seller" pill
           off whatever card carries this class */
        opt.classList.toggle('torshi-box-hero', size === PRESET_SIZE);
        var priceEl = opt.querySelector('.box-price');
        if (!priceEl) return;
        var list = jar * size;
        var now = cents / 100;
        var html = (jar > 0 && list > now)
          ? '<s>' + money(list) + '</s><span class="torshi-box-now">' + money(now) + '</span>'
          : '<span class="torshi-box-now">' + money(now) + '</span>';
        if (priceEl.innerHTML !== html) priceEl.innerHTML = html;
      });
  }

  /* Mobile opens on a bare product photo — title, price and the
     free-shipping badge sit below the fold. Move that intro block above
     the gallery on small screens so the page leads with what it is.
     Fully reversible: on desktop widths the blocks go back to their
     original spot in the right column (markers remember where), so
     resizing the window never leaves the layout distorted. */
  var torshiHeadMq = window.matchMedia('(max-width: 959px)');
  function relocateMobileHeader() {
    var wrap = document.querySelector('.torshi-mobile-head');
    if (torshiHeadMq.matches) {
      if (wrap) return;
      var primary = document.querySelector('.main-product-section .product__primary');
      var meta = document.querySelector('.main-product-section .product__meta');
      if (!primary || !meta) return;
      var header = meta.querySelector(':scope > .product__block--header') ||
                   (meta.querySelector('h1') && meta.querySelector('h1').closest('.product__block'));
      if (!header || !header.querySelector('.torshi-price-line')) return; /* wait for the price line */
      var callout = meta.querySelector(':scope > .product__block-callouts-mini');
      wrap = document.createElement('div');
      wrap.className = 'torshi-mobile-head';
      primary.insertBefore(wrap, primary.firstChild);
      [header, callout].forEach(function (block) {
        if (!block) return;
        if (!block.torshiHomeMarker) {
          var m = document.createElement('div');
          m.style.display = 'none';
          block.parentNode.insertBefore(m, block);
          block.torshiHomeMarker = m;
        }
        wrap.appendChild(block);
      });
    } else if (wrap) {
      [].slice.call(wrap.children).forEach(function (block) {
        var m = block.torshiHomeMarker;
        if (m && m.parentNode) m.parentNode.insertBefore(block, m.nextSibling);
      });
      wrap.remove();
    }
  }
  torshiHeadMq.addEventListener('change', relocateMobileHeader);

  /* ---- "Fill it with our favourites" — one-tap autofill ----
     Lives in the cart under the box-size picker. Fills the REMAINING
     slots of the selected box with the recommended mix (one of each
     in-stock flavour, extras round-robin on bestsellers) — it tops up
     around whatever the customer already picked, it never clears.
     Uses the app's own add/plus buttons, so cart, counter and pricing
     stay in sync and the jars animate into their slots one by one. */
  var AUTOFILL_LABEL = '\u2728 Fill it with our favourites';
  var autofillBusy = false;

  function boxState() {
    var sel = document.querySelector('#bundlesuiteContainer .side-cart-stepper .box-options-container .box-option.selected');
    var size = sel ? parseInt(sel.getAttribute('data-box-size'), 10) : 0;
    var count = parseInt((document.querySelector('#bundlesuiteContainer .added-products-count') || {}).textContent, 10) || 0;
    return { size: size, count: count };
  }

  /* ---- Collapsed mobile cart bar ----
     Minimized, the app's bottom sheet still stood 388px tall (46% of an
     844px screen) with the box-size picker inside it — Clarity recordings
     showed customers struggling to find the products underneath. In the
     shrink state everything is swapped for one slim bar: fill progress
     (the motivator), the live total (the only question mid-add), and a
     chevron. Tapping expands the sheet via the app's own toggler. When
     the box is full the bar flips green and reads as the checkout call —
     completion should be the loudest the cart ever gets. */
  function cartTotalText() {
    var t = document.querySelector('#bundlesuiteContainer .side-cart-checkout-item.total');
    var m = t ? (t.innerText || '').match(/\$[\d,.]+/g) : null;
    return m ? m[m.length - 1] : '';
  }
  function ensureCartBar() {
    var cart = document.querySelector('#bundlesuiteContainer .side-cart-container.mobile-cart');
    if (!cart) return;
    var bar = cart.querySelector('.torshi-cartbar');
    if (!bar) {
      bar = document.createElement('button');
      bar.type = 'button';
      bar.className = 'torshi-cartbar';
      bar.innerHTML =
        '<span class="torshi-cartbar-chevron" aria-hidden="true">▲</span>' +
        '<span class="torshi-cartbar-row">' +
        '<span class="torshi-cartbar-label"></span>' +
        '<span class="torshi-cartbar-total"></span>' +
        '</span>' +
        '<span class="torshi-cartbar-track"><span class="torshi-cartbar-fill"></span></span>';
      cart.insertBefore(bar, cart.firstChild);
      bar.addEventListener('click', function (e) {
        /* keep the app's own sheet-tap handlers out of it — ours is the
           only action on this tap */
        e.stopPropagation();
        var st = boxState();
        if (st.size > 0 && st.count >= st.size) {
          /* "tap to checkout" means checkout: same handoff as Buy now —
             the app lands on /cart, the theme.liquid flag bounces it
             straight on to /checkout */
          var cta = document.querySelector('#bundlesuiteContainer .side-cart-checkout-cta button');
          if (cta && !cta.disabled) {
            try { sessionStorage.setItem('torshiBuyNow', '1'); } catch (err) {}
            cta.click();
            return;
          }
        }
        var tog = cart.querySelector('.side-cart-toggler');
        if (tog) tog.click();
      });
    }
    updateCartBar();
  }
  /* The app stamps its Checkout button "requirements-not-met" on mount and
     never takes it off — a full box still showed a grey, not-allowed button
     (with a "Tier requirements not yet met" tooltip) that nonetheless went
     to checkout on click. Derive the state from the jar count instead:
     full box = ready (navy), anything less keeps the grey. */
  function syncCheckoutCta() {
    var cta = document.querySelector('#bundlesuiteContainer .side-cart-checkout-cta button');
    if (!cta) return;
    var st = boxState();
    var ready = st.size > 0 && st.count >= st.size;
    cta.classList.toggle('torshi-cta-ready', ready);
    cta.classList.toggle('requirements-not-met', !ready);
    var title = ready ? '' : 'Fill your box to check out';
    if (cta.title !== title) cta.title = title;
  }
  function updateCartBar() {
    var cart = document.querySelector('#bundlesuiteContainer .side-cart-container.mobile-cart');
    var bar = cart ? cart.querySelector('.torshi-cartbar') : null;
    if (!bar) return;
    var st = boxState();
    var full = st.size > 0 && st.count >= st.size;
    bar.classList.toggle('torshi-cartbar-full', full);
    var label = full
      ? '✓ Box full — tap to checkout'
      : (st.size > 0
        ? 'Your box · ' + st.count + '/' + st.size + ' jars'
        : 'Your box · ' + st.count + ' item' + (st.count === 1 ? '' : 's'));
    var l = bar.querySelector('.torshi-cartbar-label');
    var t = bar.querySelector('.torshi-cartbar-total');
    if (l.textContent !== label) l.textContent = label;
    var total = cartTotalText();
    if (t.textContent !== total) t.textContent = total;
    var fill = bar.querySelector('.torshi-cartbar-fill');
    if (fill) {
      var pct = st.size > 0 ? Math.min(100, Math.round(st.count / st.size * 100)) : 0;
      var w = pct + '%';
      if (fill.style.width !== w) fill.style.width = w;
    }
  }

  /* Desktop fill indicator. The app's "Add N more item(s) to fill your
     box" line was a solid navy block that read as a button — Clarity
     showed customers clicking it expecting it to fill the box. Replace it
     with a read-only progress row (n of size + track), the same visual
     the collapsed mobile bar uses. The app's own h3 stays in the DOM (the
     app keeps rewriting it) and is hidden by CSS at desktop widths. */
  function ensureBoxProgress() {
    var host = document.querySelector('#bundlesuiteContainer .side-cart-stepper .discount-info-container');
    if (!host) return;
    var bar = host.querySelector('.torshi-progress');
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'torshi-progress';
      bar.setAttribute('role', 'progressbar');
      bar.setAttribute('aria-valuemin', '0');
      bar.innerHTML =
        '<span class="torshi-progress-row">' +
        '<span class="torshi-progress-label"></span>' +
        '<span class="torshi-progress-hint"></span>' +
        '</span>' +
        '<span class="torshi-progress-track"><span class="torshi-progress-fill"></span></span>';
      host.appendChild(bar);
    }
    var st = boxState();
    var full = st.size > 0 && st.count >= st.size;
    var left = Math.max(st.size - st.count, 0);
    bar.classList.toggle('torshi-progress-full', full);
    var label = st.size > 0
      ? st.count + ' of ' + st.size + ' jars'
      : st.count + ' jar' + (st.count === 1 ? '' : 's');
    var hint = full
      ? '✓ Box full — ready to check out'
      : (st.size > 0
        ? (st.count === 0 ? 'Pick any ' + st.size : 'Add ' + left + ' more')
        : 'Pick a box size');
    /* guard every write — this runs from a childList observer */
    var l = bar.querySelector('.torshi-progress-label');
    var h = bar.querySelector('.torshi-progress-hint');
    if (l.textContent !== label) l.textContent = label;
    if (h.textContent !== hint) h.textContent = hint;
    var max = String(st.size || 0), now = String(Math.min(st.count, st.size || st.count));
    if (bar.getAttribute('aria-valuemax') !== max) bar.setAttribute('aria-valuemax', max);
    if (bar.getAttribute('aria-valuenow') !== now) bar.setAttribute('aria-valuenow', now);
    var w = st.size > 0 ? Math.min(100, Math.round(st.count / st.size * 100)) + '%' : '0%';
    var fill = bar.querySelector('.torshi-progress-fill');
    if (fill.style.width !== w) fill.style.width = w;
  }

  function ensureAutofill() {
    var stepper = document.querySelector('#bundlesuiteContainer .side-cart-stepper');
    if (!stepper) return;
    var btn = stepper.querySelector('.torshi-autofill');
    if (!stepper.querySelector('.boxed-discount-stepper')) { if (btn) btn.remove(); return; }
    if (!btn) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'torshi-autofill';
      btn.textContent = AUTOFILL_LABEL;
      btn.addEventListener('click', function () { runAutofill(btn); });
      stepper.appendChild(btn);
    }
    if (!autofillBusy) {
      var st = boxState();
      var show = st.size > 0 && st.count < st.size;
      btn.style.display = show ? '' : 'none';
      if (show && btn.textContent !== AUTOFILL_LABEL) btn.textContent = AUTOFILL_LABEL;
    }
  }

  function runAutofill(btn) {
    if (autofillBusy || presetBusy) return;
    var st = boxState();
    var need = st.size - st.count;
    var cards = inStockCards();
    if (need <= 0 || !cards.length) return;
    /* target composition for this box size: one of each, extras
       round-robin in card order (bestsellers first) */
    var hs = cards.map(function (c) { return c.getAttribute('data-product-handle'); });
    var target = {};
    hs.forEach(function (h) { target[h] = 0; });
    for (var i = 0; i < st.size; i++) target[hs[i % hs.length]] += 1;
    var steps = [];
    cards.forEach(function (c) {
      var h = c.getAttribute('data-product-handle');
      var qc = c.querySelector('.quantity-controls');
      var input = c.querySelector('.quantity-input');
      var cur = (qc && getComputedStyle(qc).display !== 'none' && input) ? (parseInt(input.value, 10) || 0) : 0;
      for (var k = cur; k < target[h]; k++) steps.push(h);
    });
    steps = steps.slice(0, need);
    var j = 0; /* customer over-picked some flavour — top up with the rest */
    while (steps.length < need) { steps.push(hs[j % hs.length]); j += 1; }
    autofillBusy = true;
    btn.disabled = true;
    allowCart();
    var total = need, done = 0;
    (function tick() {
      if (!steps.length) {
        btn.textContent = '\u2713 Packed with our favourites';
        btn.disabled = false;
        autofillBusy = false;
        ensureAutofill();
        return;
      }
      var card = cardByHandle(steps.shift());
      if (card) {
        var add = card.querySelector('.add-button');
        if (add && getComputedStyle(add).display !== 'none') add.click();
        else { var p = card.querySelector('.quantity-btn.plus'); if (p) p.click(); }
        done += 1;
        btn.textContent = 'Packing your box\u2026 ' + done + '/' + total;
      }
      setTimeout(tick, 550);
    })();
  }

  /* The widget cart (desktop side column / mobile bottom sheet) stays
     hidden until it is actually useful: the customer opened the
     customizer, finished the preset, or already has items in the box. */
  function allowCart() {
    var c = document.getElementById('bundlesuiteContainer');
    if (c) c.classList.add('torshi-cart-allowed');
  }
  function syncCartAllowed() {
    var count = document.querySelector('#bundlesuiteContainer .added-products-count');
    if (count && parseInt(count.textContent, 10) > 0) allowCart();
  }

  /* Reorder: "★ Torshi at a Glance" (+ its checklist and closing
     paragraph) and the FAQ accordions move below the builder, in that
     order. Runs late (once the widget exists) so the theme has already
     bound the accordion toggles. */
  function relocateBelowBuilder() {
    var meta = document.querySelector('.main-product-section .product__meta');
    var mount = document.querySelector('.' + MOUNT_CLASS);
    if (!meta || !mount) return;

    var anchor = mount;

    /* 1. Torshi at a Glance block group */
    var glanceWrap = document.querySelector('.torshi-glance-relocated');
    if (!glanceWrap) {
      var start = null;
      var kids = meta.children;
      for (var i = 0; i < kids.length; i++) {
        var cls = (kids[i].className || '').toString();
        if (cls.indexOf('product__block') > -1 && kids[i].textContent.indexOf('at a Glance') > -1) {
          start = kids[i];
          break;
        }
      }
      if (start) {
        var toMove = [start];
        var n = start.nextElementSibling;
        while (
          n &&
          (n.className || '').toString().indexOf('product__block') > -1 &&
          n.textContent.indexOf('Adding product') === -1
        ) {
          toMove.push(n);
          n = n.nextElementSibling;
        }
        glanceWrap = document.createElement('div');
        glanceWrap.className = 'torshi-glance-relocated';
        toMove.forEach(function (b) {
          glanceWrap.appendChild(b);
        });
        anchor.after(glanceWrap);
      }
    }
    if (glanceWrap) anchor = glanceWrap;

    /* 2. FAQ accordions */
    if (!document.querySelector('.torshi-faq-relocated')) {
      var accs = meta.querySelectorAll(':scope > .accordion');
      if (accs.length) {
        var faqWrap = document.createElement('div');
        faqWrap.className = 'torshi-faq-relocated';
        var heading = document.createElement('h3');
        heading.className = 'torshi-faq-heading';
        heading.textContent = 'Common Questions';
        faqWrap.appendChild(heading);
        accs.forEach(function (a) {
          faqWrap.appendChild(a);
        });
        anchor.after(faqWrap);
      }
    }
  }

  /* ============================================================
     "Most Popular" preset (one-click pre-built box)
     Lives inside the PDP right column, right under the
     "Select the most popular or customize your box👇" heading.
     Composition: one of each in-stock flavour, extras distributed
     from the top of the list until PRESET_SIZE jars. Adding is done
     through the app's own card buttons, so the tier discount, cart
     and checkout all behave exactly as if the customer clicked.
     Arm A (default): product grid starts collapsed behind
     "customize your own". Arm B (?arm=open): grid starts open.
     ============================================================ */
  var PRESET_SIZE = 6;
  var presetBusy = false;

  function getTiers() {
    /* Parsed from the cart stepper. Supports both tier styles the app
       offers: percentage ("15% OFF") and fixed price ("Fixed price
       $75.00"). [{min, pct, fixed}] */
    var tiers = [];
    document.querySelectorAll('#bundlesuiteContainer .side-cart-stepper .discount-stepper-item').forEach(function (item) {
      var th = item.querySelector('.threshold-count');
      var val = item.querySelector('.discount-value p');
      if (th && val) {
        var text = val.getAttribute('data-torshi-raw') || val.textContent;
        var pctMatch = text.match(/([\d.]+)\s*%/);
        var fixedMatch = text.match(/\$\s*([\d,]+(?:\.\d+)?)/);
        tiers.push({
          min: parseInt(th.textContent, 10),
          pct: pctMatch ? parseFloat(pctMatch[1]) : 0,
          fixed: !pctMatch && fixedMatch ? parseFloat(fixedMatch[1].replace(/,/g, '')) : 0
        });
      }
    });
    /* Fixed-box mode ("Sell as fixed boxes") renders box cards instead
       of a tier stepper: 3 items / $40, 6 / $75, 12 / $119.99. Each
       card carries its size and price in cents as data attributes. */
    if (!tiers.length) {
      var seen = {};
      document.querySelectorAll('#bundlesuiteContainer .box-option').forEach(function (b) {
        var size = parseInt(b.getAttribute('data-box-size'), 10);
        var cents = parseInt(b.getAttribute('data-box-price'), 10);
        if (!(size > 0) || !(cents > 0) || seen[size]) return;
        seen[size] = 1;
        tiers.push({ min: size, pct: 0, fixed: cents / 100 });
      });
    }
    tiers.sort(function (a, b) { return a.min - b.min; });
    return tiers;
  }

  function tiersReady() {
    return getTiers().some(function (t) { return t.pct > 0 || t.fixed > 0; });
  }

  function dealForCount(count, subtotal) {
    /* returns {price, savingsPct} for a box of `count` jars */
    var best = null;
    getTiers().forEach(function (t) { if (count >= t.min) best = t; });
    if (best && best.pct > 0) {
      return { price: subtotal * (1 - best.pct / 100), savingsPct: Math.round(best.pct) };
    }
    if (best && best.fixed > 0 && best.fixed < subtotal) {
      return { price: best.fixed, savingsPct: Math.round((1 - best.fixed / subtotal) * 100) };
    }
    return { price: subtotal, savingsPct: 0 };
  }

  function inStockCards() {
    return [].slice.call(
      document.querySelectorAll('#bundlesuiteContainer .product-card')
    ).filter(function (c) {
      var b = c.querySelector('.add-button');
      return b && b.getAttribute('data-stock-status') === 'in-stock';
    });
  }

  function presetPlan() {
    // returns [{handle, qty, title, price}] — one of each, extras round-robin
    var cards = inStockCards();
    if (!cards.length) return [];
    var plan = cards.slice(0, PRESET_SIZE).map(function (c) {
      return {
        handle: c.getAttribute('data-product-handle'),
        title: (c.querySelector('.product-title h4') || {}).textContent || '',
        price: parseFloat(((c.querySelector('.product-price p') || {}).textContent || '').replace(/[^\d.]/g, '')) || 0,
        qty: 1
      };
    });
    var total = plan.length;
    var i = 0;
    while (total < PRESET_SIZE && plan.length) {
      plan[i % plan.length].qty += 1;
      total += 1;
      i += 1;
    }
    return plan;
  }

  function cardByHandle(handle) {
    return document.querySelector('#bundlesuiteContainer .product-card[data-product-handle="' + handle + '"]');
  }

  /* Flag the bestselling flavour in the picker grid. Keyed on the
     handle, with a title fallback so renaming the product in Shopify
     doesn't silently drop the badge. The pill itself is CSS. */
  var POPULAR_HANDLE = 'torshi-500-ml';       // Mixed Vegetable Torshi (500 ml)
  var POPULAR_TITLE = /mixed\s*vegetable/i;

  function markPopularCard() {
    var container = document.getElementById('bundlesuiteContainer');
    if (!container) return;
    var card = cardByHandle(POPULAR_HANDLE);
    if (!card) {
      var cards = container.querySelectorAll('.product-card');
      for (var i = 0; i < cards.length; i++) {
        var t = cards[i].querySelector('.product-title h4');
        if (t && POPULAR_TITLE.test(t.textContent)) { card = cards[i]; break; }
      }
    }
    if (card && !card.classList.contains('torshi-pop')) card.classList.add('torshi-pop');
  }

  /* Empty the box through the app's own minus buttons, one unit at a
     time, so the cart, the box-fill counter and the discount all stay
     in sync. Bounded, so a stuck card can never spin forever. */
  function clearBox(done, guard) {
    guard = guard || 0;
    if (guard > 60) { done(); return; }
    var card = null;
    var cards = document.querySelectorAll('#bundlesuiteContainer .product-card');
    for (var i = 0; i < cards.length; i++) {
      var input = cards[i].querySelector('.quantity-input');
      var qc = cards[i].querySelector('.quantity-controls');
      if (input && qc && getComputedStyle(qc).display !== 'none' &&
          parseInt(input.value, 10) > 0) { card = cards[i]; break; }
    }
    if (!card) { done(); return; }
    var minus = card.querySelector('.quantity-btn.minus');
    if (!minus) { done(); return; }
    minus.click();
    setTimeout(function () { clearBox(done, guard + 1); }, 320);
  }

  /* Fixed-box mode: the preset is a 6-jar box, so make sure the 6-item
     box is the selected one before filling it. No-op on tiered pricing. */
  function selectPresetBox() {
    var opt = document.querySelector(
      '#bundlesuiteContainer .box-options-container .box-option[data-box-size="' + PRESET_SIZE + '"]');
    if (opt && !opt.classList.contains('selected')) opt.click();
  }

  /* ?size=3|6|12 — deep link from the shop page's bundle widget. The
     customer already chose a box size there; honour it on arrival:
     preselect that box, open the flavour grid and scroll to it, so the
     only decision left is flavours. No param (or an unknown size) leaves
     the page exactly as it was. Retries because the app renders the box
     options on its own schedule. */
  var sizeParamDone = false;
  function applySizeParam(tries) {
    if (sizeParamDone) return;
    tries = tries || 0;
    var m = window.location.search.match(/[?&]size=(\d+)/);
    if (!m) { sizeParamDone = true; return; }
    var size = parseInt(m[1], 10);
    var opt = document.querySelector(
      '#bundlesuiteContainer .side-cart-stepper .box-options-container .box-option[data-box-size="' + size + '"]');
    if (!opt) {
      if (tries < 60) { setTimeout(function () { applySizeParam(tries + 1); }, 250); }
      else { sizeParamDone = true; }
      return;
    }
    sizeParamDone = true;
    allowCart();
    if (!opt.classList.contains('selected')) opt.click();
    toggleGrid(true);
  }

  /* A customer who pressed "Buy now" has already decided. Revealing the
     box-size picker and the autofill button mid-purchase re-opens a
     choice they just closed ("oh — I could pick different ones"), which
     is exactly the hesitation this one-click path exists to avoid. While
     the preset runs, the cart shows only the receipt half: the jars
     dropping into their slots and the toast naming each one. CSS keyed
     on this class does the hiding. */
  function setPresetRunning(on) {
    var c = document.getElementById('bundlesuiteContainer');
    if (c) c.classList.toggle('torshi-preset-running', !!on);
  }

  function runPreset(btn) {
    if (presetBusy) return;
    var plan = presetPlan();
    if (!plan.length) return;
    presetBusy = true;
    setPresetRunning(true);
    btn.classList.add('torshi-preset-busy');
    btn.textContent = 'Building your box…';
    /* Start from a clean box — otherwise whatever the customer already
       added is counted toward the preset and the result is a box that
       is neither theirs nor the preset. */
    allowCart();
    selectPresetBox();
    setTimeout(function () { clearBox(function () { fillPreset(btn, plan); }); }, 400);
  }

  /* Buy-now handoff: the box is full, so the app has enabled its own
     Checkout button — press it. The app owns cart creation and the
     redirect, so this stays correct if its checkout flow changes.
     Polls briefly because enabling happens on the app's own tick; if it
     never enables (e.g. stock ran out mid-fill), the button resets so
     the customer is never stranded on a dead label. */
  function goToCheckout(btn, needed, tries) {
    tries = tries || 0;
    var cta = document.querySelector('#bundlesuiteContainer .side-cart-checkout-cta button');
    var count = parseInt((document.querySelector('#bundlesuiteContainer .added-products-count') || {}).textContent, 10) || 0;
    /* NB: the CTA keeps a stale "requirements-not-met" class even when the
       box is full — the app's own click handler is the source of truth, so
       gate on the box actually being full instead of the class. */
    if (cta && !cta.disabled && count >= needed) {
      /* the app's checkout lands on /cart first; this flag makes the
         theme.liquid snippet on /cart bounce straight on to /checkout */
      try { sessionStorage.setItem('torshiBuyNow', '1'); } catch (e) {}
      cta.click();
      return;
    }
    if (tries < 40) { setTimeout(function () { goToCheckout(btn, needed, tries + 1); }, 250); return; }
    /* Checkout never opened — hand the cart back in full so the customer
       can finish by hand instead of staring at a half-hidden panel. */
    setPresetRunning(false);
    ensureAutofill();
    btn.classList.remove('torshi-preset-done');
    btn.textContent = 'Buy now — checkout didn\u2019t open, tap Checkout in your cart';
  }

  function fillPreset(btn, plan) {
    var totalJars = plan.reduce(function (s, p) { return s + p.qty; }, 0);
    var done = 0;
    var steps = [];
    plan.forEach(function (p) {
      steps.push({ handle: p.handle, action: 'add' });
      for (var q = 1; q < p.qty; q++) steps.push({ handle: p.handle, action: 'plus' });
    });

    function tick() {
      if (!steps.length) {
        btn.classList.remove('torshi-preset-busy');
        btn.classList.add('torshi-preset-done');
        btn.textContent = '✓ Box ready — taking you to checkout…';
        presetBusy = false;
        allowCart();
        goToCheckout(btn, totalJars);
        return;
      }
      var step = steps.shift();
      var card = cardByHandle(step.handle);
      if (card) {
        if (step.action === 'add') {
          var add = card.querySelector('.add-button');
          if (add && getComputedStyle(add).display !== 'none') {
            add.click();
          } else {
            var plusA = card.querySelector('.quantity-btn.plus');
            if (plusA) plusA.click();
          }
        } else {
          var plus = card.querySelector('.quantity-btn.plus');
          if (plus) plus.click();
        }
        done += 1;
        btn.textContent = 'Building your box… ' + done + '/' + totalJars;
      }
      setTimeout(tick, 550);
    }
    btn.textContent = 'Building your box… 0/' + totalJars;
    tick();
  }

  function toggleGrid(explicit) {
    var container = document.getElementById('bundlesuiteContainer');
    if (!container) return;
    var collapsed = container.classList.contains('torshi-grid-collapsed');
    var open = explicit === undefined ? collapsed : explicit;
    container.classList.toggle('torshi-grid-collapsed', !open);
    var link = document.querySelector('.torshi-customize-toggle');
    if (link) {
      link.innerHTML = open
        ? 'Hide the options ▴'
        : 'or customize your own box ▾';
    }
    if (open) {
      allowCart();
      var section = container.querySelector('.individual-products-section');
      if (section) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      /* Hiding the options with an empty box: the cart is useless, hide
         it again. With jars in the box it stays. */
      var count = container.querySelector('.added-products-count');
      if (!count || !(parseInt(count.textContent, 10) > 0)) {
        container.classList.remove('torshi-cart-allowed');
      }
    }
  }

  /* ---- Builder-first (2026-09-10, Matin's call) ----
     No "Classic 6 — Buy now" card and no hide/expand: every visitor
     lands on the same open builder with the 6-jar box preselected.
     The one-click preset machinery below (buildPresetCard, runPreset,
     ensureBuyBar) is left in the file but no longer wired up. */
  var openBuilderDone = false;
  function setupOpenBuilder() {
    var container = document.getElementById('bundlesuiteContainer');
    if (!container) return;
    container.classList.remove('torshi-grid-collapsed');
    allowCart();
    /* default box size — the app normally preselects 6; make sure */
    var picker = container.querySelector('.side-cart-stepper .box-options-container');
    if (picker && !picker.querySelector('.box-option.selected')) {
      var six = picker.querySelector('.box-option[data-box-size="' + PRESET_SIZE + '"]');
      if (six) six.click();
    }
    if (openBuilderDone) return;
    var block = findCustomizeBlock();
    if (!block) return;
    openBuilderDone = true;
    /* how-it-works strip under the heading */
    var steps = document.createElement('ol');
    steps.className = 'torshi-steps';
    steps.innerHTML =
      '<li><b>1</b><span>Pick a box size</span></li>' +
      '<li><b>2</b><span>Choose your jars</span></li>' +
      '<li><b>3</b><span>Check out</span></li>';
    block.insertAdjacentElement('afterend', steps);
    /* the intro paragraph sat between the flavours link and the heading;
       it reads better after the steps, answering "what am I buying" */
    var meta = document.querySelector('.main-product-section .product__meta');
    if (meta) {
      var intro = null;
      [].forEach.call(meta.children, function (n) {
        if (intro) return;
        var cls = (n.className || '').toString();
        if (cls.indexOf('product__description') > -1) intro = n;
      });
      if (intro) {
        steps.insertAdjacentElement('afterend', intro);
        var generic = intro.textContent.indexOf('Build your own box') > -1;
        /* the product description talks about the box, which the heading
           and steps already cover — this spot is for what Torshi is.
           (Copy lives here rather than in the product record so it ships
           with the theme; move it into the description at publish.) */
        intro.classList.add('torshi-intro');
        if (generic) intro.innerHTML =
          '<p>Torshi is a Persian-style, crunchy and tangy mix of crisp ' +
          'slow-pickled vegetables in organic apple cider vinegar with fresh ' +
          'herbs, garlic and a touch of jalape\u00f1o. It is bright, sugar-free, ' +
          'and a low-calorie side designed to sit next to almost everything ' +
          'you eat.</p>';
      }
    }
  }

  function buildPresetCard() {
    if (document.querySelector('.torshi-preset')) return;
    var container = document.getElementById('bundlesuiteContainer');
    var anchorBlock = findCustomizeBlock();
    var wrapper = container ? container.querySelector('.main-product-content-container .main-wrapper') : null;
    var plan = presetPlan();
    /* wait for real tier data (thresholds AND their values), so the
       preset price is computed right */
    if (!container || !plan.length || !tiersReady()) return;
    if (!anchorBlock && !wrapper) return;

    var totalJars = plan.reduce(function (s, p) { return s + p.qty; }, 0);
    var subtotal = plan.reduce(function (s, p) { return s + p.qty * p.price; }, 0);
    var deal = dealForCount(totalJars, subtotal);
    var pct = deal.savingsPct;
    var discounted = deal.price;
    var img = container.querySelector('.product-card .product-card-image img');

    var card = document.createElement('div');
    card.className = 'torshi-preset';
    card.innerHTML =
      '<div class="torshi-preset-media">' +
      (img ? '<img src="' + img.src + '" alt="Torshi jars">' : '') +
      '</div>' +
      '<div class="torshi-preset-body">' +
      '<span class="torshi-preset-chip">★ Most popular</span>' +
      '<h3 class="torshi-preset-title">The Classic ' + totalJars + '</h3>' +
      '<p class="torshi-preset-sub">One jar of every flavour, doubled up on our bestsellers.</p>' +
      '<div class="torshi-preset-price">' +
      '<s>$' + subtotal.toFixed(2) + '</s> <strong>$' + discounted.toFixed(2) + '</strong>' +
      '<span class="torshi-preset-savechip">' + pct + '% off</span>' +
      '</div>' +
      '</div>' +
      '<div class="torshi-preset-actions">' +
      '<button type="button" class="torshi-preset-add">Buy now — ' + totalJars + ' jars</button>' +
      '<button type="button" class="torshi-customize-toggle">or customize your own box ▾</button>' +
      '</div>';

    if (anchorBlock) {
      anchorBlock.insertAdjacentElement('afterend', card);
    } else {
      wrapper.insertBefore(card, wrapper.firstChild);
    }

    card.querySelector('.torshi-preset-add').addEventListener('click', function () {
      runPreset(this);
    });
    card.querySelector('.torshi-customize-toggle').addEventListener('click', function () {
      toggleGrid();
    });

    /* The intro paragraph explains the box, but it sat between the
       gallery and the card and pushed the only buy button ~190px further
       down. It reads just as well underneath the card, where it answers
       "what am I buying" for anyone not already sold. */
    var meta = document.querySelector('.main-product-section .product__meta');
    if (meta) {
      var intro = null;
      [].forEach.call(meta.children, function (n) {
        if (intro) return;
        var cls = (n.className || '').toString();
        if (cls.indexOf('product__description') > -1) intro = n;
      });
      if (intro) card.insertAdjacentElement('afterend', intro);
    }

    /* Arm A (default): grid collapsed. Arm B: ?arm=open keeps it open. */
    var arm = (window.location.search.match(/[?&]arm=(\w+)/) || [])[1];
    if (arm !== 'open') {
      container.classList.add('torshi-grid-collapsed');
    } else {
      card.querySelector('.torshi-customize-toggle').innerHTML = 'Hide the options ▴';
      allowCart();
    }
    ensureBuyBar();
  }

  /* ---- Sticky mobile buy bar ----
     One buy button on a 9,000px page means anyone convinced further down
     has to scroll back to the top to act. Once the Classic 6 card leaves
     the screen a slim bar takes its place, so the decision is always one
     tap away. It stands down whenever the real cart is on screen (that
     has its own Checkout) or while the preset is mid-flight. */
  var buyBarMq = window.matchMedia('(max-width: 959px)');

  function ensureBuyBar() {
    if (document.querySelector('.torshi-buybar')) return;
    var card = document.querySelector('.torshi-preset');
    if (!card) return;
    var bar = document.createElement('div');
    bar.className = 'torshi-buybar';
    bar.innerHTML =
      '<button type="button" class="torshi-buybar-btn">' +
      '<span class="torshi-buybar-label"></span>' +
      '<span class="torshi-buybar-price"></span>' +
      '</button>';
    document.body.appendChild(bar);
    bar.querySelector('.torshi-buybar-btn').addEventListener('click', function () {
      var real = document.querySelector('.torshi-preset-add');
      if (!real) return;
      card.scrollIntoView({ behavior: 'smooth', block: 'center' });
      runPreset(real);
    });
    window.addEventListener('scroll', updateBuyBar, { passive: true });
    window.addEventListener('resize', updateBuyBar);
    buyBarMq.addEventListener('change', updateBuyBar);
    updateBuyBar();
  }

  function updateBuyBar() {
    var bar = document.querySelector('.torshi-buybar');
    var real = document.querySelector('.torshi-preset-add');
    if (!bar || !real) return;
    var container = document.getElementById('bundlesuiteContainer');
    var cartUp = container && container.classList.contains('torshi-cart-allowed');
    /* only once the real button has scrolled off the top */
    var past = real.getBoundingClientRect().bottom < 0;
    var show = buyBarMq.matches && past && !cartUp && !presetBusy;
    bar.classList.toggle('torshi-buybar-on', !!show);
    if (show) {
      var priceEl = document.querySelector('.torshi-preset-price strong');
      bar.querySelector('.torshi-buybar-label').textContent = real.textContent.replace(/\s*—.*$/, '');
      bar.querySelector('.torshi-buybar-price').textContent = priceEl ? priceEl.textContent : '';
    }
  }

  /* Keep the PDP "From $X / jar — save up to Y%" line in sync with the
     app's live tier config (works for both % and fixed-price tiers). */
  function refreshPdpPriceLine() {
    var line = document.querySelector('.torshi-price-line');
    if (!line || line.dataset.synced === '1' || !tiersReady()) return;
    var cards = inStockCards();
    if (!cards.length) return;
    var jar = parseFloat(((cards[0].querySelector('.product-price p') || {}).textContent || '').replace(/[^\d.]/g, '')) || 0;
    if (!jar) return;
    var bestPerJar = jar;
    var maxSave = 0;
    getTiers().forEach(function (t) {
      if (t.min > 0) {
        var sub = t.min * jar;
        var d = dealForCount(t.min, sub);
        if (d.price / t.min < bestPerJar) bestPerJar = d.price / t.min;
        if (d.savingsPct > maxSave) maxSave = d.savingsPct;
      }
    });
    line.innerHTML =
      'From <strong>$' + bestPerJar.toFixed(2) + '</strong> / jar' +
      (maxSave > 0 ? ' <span class="torshi-save-chip">Save up to ' + maxSave + '%</span>' : '');
    line.dataset.synced = '1';
  }

  /* If the card ever rendered before the tier percentages arrived,
     recompute the price line once real data is available. */
  function refreshPresetPrice() {
    var preset = document.querySelector('.torshi-preset');
    if (!preset || preset.dataset.priced === '1') return;
    var plan = presetPlan();
    if (!plan.length) return;
    var totalJars = plan.reduce(function (s, p) { return s + p.qty; }, 0);
    var subtotal = plan.reduce(function (s, p) { return s + p.qty * p.price; }, 0);
    var deal = dealForCount(totalJars, subtotal);
    var pct = deal.savingsPct;
    if (pct <= 0) return;
    var discounted = deal.price;
    var priceEl = preset.querySelector('.torshi-preset-price');
    if (priceEl) {
      priceEl.innerHTML =
        '<s>$' + subtotal.toFixed(2) + '</s> <strong>$' + discounted.toFixed(2) + '</strong>' +
        '<span class="torshi-preset-savechip">' + pct + '% off</span>';
      preset.dataset.priced = '1';
    }
  }

  /* Hover on a builder card shows the product's second image.
     Second images aren't in the widget DOM, so they're fetched once
     per product from the public /products/<handle>.js endpoint.
     Delegated listeners survive the widget's re-renders. */
  var secondImages = {};
  var hoverBound = false;
  function bindHoverSwap(container) {
    if (hoverBound) return;
    hoverBound = true;

    function cardImg(card) {
      return card.querySelector('.product-card-image img');
    }
    function swapTo(img, url) {
      if (!img.dataset.torshiOrigSrc) {
        img.dataset.torshiOrigSrc = img.src;
        if (img.srcset) {
          img.dataset.torshiOrigSrcset = img.srcset;
        }
      }
      img.removeAttribute('srcset');
      img.src = url;
    }
    function restore(img) {
      if (img.dataset.torshiOrigSrc) {
        img.src = img.dataset.torshiOrigSrc;
        if (img.dataset.torshiOrigSrcset) {
          img.srcset = img.dataset.torshiOrigSrcset;
        }
      }
    }

    container.addEventListener('mouseover', function (e) {
      var card = e.target.closest ? e.target.closest('.product-card') : null;
      if (!card) return;
      var handle = card.getAttribute('data-product-handle');
      var img = cardImg(card);
      if (!handle || !img) return;

      if (!(handle in secondImages)) {
        secondImages[handle] = null; // fetch in flight
        fetch('/products/' + handle + '.js')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            if (d && d.images && d.images.length > 1) {
              var u = d.images[1];
              if (u.indexOf('//') === 0) u = 'https:' + u;
              u += (u.indexOf('?') > -1 ? '&' : '?') + 'width=600';
              secondImages[handle] = u;
              var pre = new Image();
              pre.src = u;
              if (card.matches(':hover')) swapTo(cardImg(card), u);
            }
          })
          .catch(function () {});
      } else if (secondImages[handle]) {
        swapTo(img, secondImages[handle]);
      }
    });

    container.addEventListener('mouseout', function (e) {
      var card = e.target.closest ? e.target.closest('.product-card') : null;
      if (!card) return;
      if (e.relatedTarget && card.contains(e.relatedTarget)) return;
      var img = cardImg(card);
      if (img) restore(img);
    });
  }

  function apply() {
    ensureMount();
    patchPdp();
    patchCustomizeHeading();
    patchButtons();
    patchSectionTitles();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }

  /* The widget mounts asynchronously and re-renders on state changes:
     poll until it appears, then keep the buttons patched. */
  var tries = 0;
  var poll = setInterval(function () {
    tries++;
    apply();
    ensureHeatMeter();
    var container = document.getElementById('bundlesuiteContainer');
    if (container || tries > 100) {
      clearInterval(poll);
      relocateBelowBuilder();
      if (container) {
        setupOpenBuilder();
        patchStepperLabels();
        patchBoxOptions();
        ensureAutofill();
        ensureCartBar();
        ensureBoxProgress();
        syncCheckoutCta();
        markPopularCard();
        relocateMobileHeader();
        syncCartAllowed();
        applySizeParam();
        bindHoverSwap(container);
        new MutationObserver(function () {
          patchButtons();
          patchSectionTitles();
          patchStepperLabels();
          patchBoxOptions();
          ensureAutofill();
          ensureCartBar();
          ensureBoxProgress();
          syncCheckoutCta();
          markPopularCard();
          relocateMobileHeader();
          setupOpenBuilder();
          refreshPresetPrice();
          refreshPdpPriceLine();
          syncCartAllowed();
          ensureBuyBar();
          updateBuyBar();
        }).observe(container, { childList: true, subtree: true });
      }
    }
  }, 100);
})();







